Ext.define('SA.AcsTable.TableSearchController', {
    constructor({field, input, popup, popupSizeGauge, observable}) {
        this.field = field;
        this.input = input;
        this.popup = popup;
        this.popupSizeGauge = popupSizeGauge;
        this.observable = observable;

        this.data = [];
        this.hasMatches = false;
    },

    applyFilter() {
        var regex = SA.AcsTable.TableSearchRegex.fromString(this.input.value),
            matchedData = this.data.filter(item => item.name.match(regex));

        this.hasMatches = matchedData.length > 0;

        this.popup.setData(matchedData);
        this.popupSizeGauge.setData(matchedData);
    },

    hidePopup() {
        this.popup.hide();
    },

    onClearBtnMouseDown(ev) {
        this.input.value = '';
        this.input.focus();
        this.applyFilter();
        this.showPopup();
        this.refreshSizing();

        ev.preventDefault(); 
    },

    onInputBlur() {
        this.hidePopup();
    },

    onInputEscapeKeydown() {
        this.hidePopup();
    },

    onInputFocus() {
        if (!this.hasMatches) {
            return;
        }

        this.showPopup();
        this.refreshSizing();
    },

    onFieldInput() {
        this.applyFilter();

        if (!this.hasMatches) {
            this.hidePopup();
            return;
        }

        this.showPopup();
        this.refreshSizing();
    },

    onPopupBtnMouseDown({btn}) {
        this.hidePopup();
        this.observable.fireEvent('select:tableItem', btn.dataset.tableId);
    },

    onViewportResize() {
        this.refreshSizing();
    },

    refreshSizing() {
        this.popup.setSizing(this.popupSizeGauge.resolveSizing());
    },

    setData(data) {
        this.data = data;
        this.applyFilter();
    },

    showPopup() {
        this.popup.show();
    }
});